import {
    AfterContentInit,
    AfterViewChecked,
    AfterViewInit,
    Component,
    HostListener,
    inject,
    NgZone,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import {UserCtaComponent} from "../../shared/components/user-cta/user-cta.component";
import {ConsultancyHeadComponent} from "../../shared/components/consultancy-head/consultancy-head.component";
import {NgbAccordionModule, NgbCarouselModule, NgbProgressbar} from "@ng-bootstrap/ng-bootstrap";
import {CONSULTANCY_CARD_ARRAY, PERFORMANCE_ARRAY, PRICING_NAV_ARR, PRODUCTS_ARRAY} from "../../constants/constants";
import {QeleoIconComponent} from "../../shared/components/qeleo-icon/qeleo-icon.component";
import {CommonModule} from "@angular/common";
import {ScreenSizeService} from "../../core/services/screen-size.service";
import {ViewportDirective} from "../../core/directives/viewport.directive";
import {ModalService} from "../../core/services/modal.service";
import {PricingHeadComponent} from '../../shared/components/pricing-head/pricing-head.component';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [
        NgbAccordionModule,
        UserCtaComponent,
        ConsultancyHeadComponent,
        QeleoIconComponent,
        CommonModule,
        NgbCarouselModule,
        NgbProgressbar,
        ViewportDirective,
        PricingHeadComponent
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
})
export class HomeComponent implements OnDestroy {
    @ViewChild('productAccordion') accordion?: any;
    // productsArr: any[] = [...PRODUCTS_ARRAY];
    productsImages: any = {
        developer: {
            light: "../../../assets/images/products/developer-light.jpg",
            dark: "../../../assets/images/products/developer_dark.png"
        },
        prompt: {
            light: "../../../assets/images/products/prompt_light.png",
            dark: "../../../assets/images/products/prompt_dark.png"
        },
        chat: {
            light: "../../../assets/images/products/chat_light.png",
            dark: "../../../assets/images/products/chat_dark.png"
        }
    }
    performanceArr: any[] = [...PERFORMANCE_ARRAY];
    pricingNavArr: string[] = [...PRICING_NAV_ARR]
    selectedTheme: string = 'light';
    activePerformance: string = this.performanceArr[0].subTitle;
    images = [1055, 194, 368].map((n) => `https://picsum.photos/id/${n}/900/500`);
    activePricingNav: string = this.pricingNavArr[0];
    currentCardIndex: number = 0;
    hoverCardIndex: number = -1;
    showPerformanceCard: boolean = false;
    cardIntervalId: any;
    accordionIntervalId: any;
    cardProgressValue: number = 0;
    accordionProgressValue: number = 0;
    productsArr: string[] = ['developer', 'prompt', 'chat'];
    currentAccordionIndex: number = 0;
    activeProductImage: string = this.productsImages.developer.light;
    hoverAccordionIndex: number = -1;
    private ngZone: NgZone = inject(NgZone);
    private cardProgressTimeoutId: any;
    private cardProgressIntervalId: any;
    private accordionProgressTimeoutId: any;
    private accordionProgressIntervalId: any;
    private isFirstTimeInPerformanceCards: boolean = true;
    private isFirstTimeInProductAccordion: boolean = true;
    private screenSizeService = inject(ScreenSizeService)
    isSmallScreen$ = this.screenSizeService.isSmallScreen$;

    @HostListener("document:visibilitychange", ["$event"])
    onVisibilityChange(event: Event): void {
        if (document.hidden) {
            if (!this.isFirstTimeInProductAccordion) {
                this.stopCardCycle("productsAccordion");
            }
            if (!this.isFirstTimeInPerformanceCards) {
                this.stopCardCycle("performanceCards");
            }
        } else {
            if (!this.isFirstTimeInProductAccordion) {
                this.startFromAccordion(this.productsArr[this.currentAccordionIndex]);
            }
            if (!this.isFirstTimeInPerformanceCards) {
                this.startFromCard(this.currentCardIndex);
            }
        }
    }

  ngOnDestroy(): void {
    this.stopCardCycle("performanceCards");
    this.stopCardCycle("productsAccordion");
  }

    onToggle(itemId: string, event?: any,) {
        this.hoverAccordionIndex = -1;
        this.startFromAccordion(itemId);
        if (!this.accordion.isExpanded(itemId)) {
            this.accordion.expand(itemId);
        }
    }

    setTheme(themeName: string) {
        this.selectedTheme = themeName;
        this.setProductImage();
    }

    setProductImage() {
        const activeAccordion = this.productsArr[this.hoverAccordionIndex !== -1 ? this.hoverAccordionIndex : this.currentAccordionIndex];
        this.activeProductImage = this.productsImages[activeAccordion][this.selectedTheme];
    }

    onPricingNavChange(navName: string) {
        this.activePricingNav = navName;
    }

    onInViewport(isInViewport: boolean, viewPortFor: string) {
        this.ngZone.run(() => {
            if (isInViewport) {
                if (viewPortFor === 'performanceCards' && this.isFirstTimeInPerformanceCards) {
                    this.currentCardIndex = 0;
                    this.startCardProgress(false);
                    this.startCardCycle();
                    this.isFirstTimeInPerformanceCards = false
                } else if (this.isFirstTimeInProductAccordion) {
                    this.currentAccordionIndex = 0;
                    this.accordion.expand(this.productsArr[this.currentAccordionIndex])
                    this.startAccordionProgress();
                    this.startAccordionCycle();
                    this.isFirstTimeInProductAccordion = false
                }
            }
        });
    }

    startCardCycle() {
        this.showPerformanceCard = true;
        this.cardIntervalId = setInterval(() => {
            this.currentCardIndex =
                (this.currentCardIndex + 1) % this.performanceArr.length;
            this.startCardProgress(false);
        }, 6000);
    }

    startAccordionCycle() {
        this.accordionIntervalId = setInterval(() => {
            this.currentAccordionIndex =
                (this.currentAccordionIndex + 1) % this.productsArr.length;
            this.startAccordionProgress();
            this.accordion.expand(this.productsArr[this.currentAccordionIndex]);
            this.setProductImage();
        }, 9500);
    }

    stopCardCycle(activeViewPort: string) {
        if (activeViewPort === 'performanceCards') {
            this.showPerformanceCard = false;
            clearInterval(this.cardProgressIntervalId);
            clearInterval(this.cardProgressTimeoutId);
            clearInterval(this.cardIntervalId);
            this.cardProgressValue = 0;
        } else {
            clearInterval(this.accordionProgressIntervalId);
            clearInterval(this.accordionProgressTimeoutId);
            clearInterval(this.accordionIntervalId);
            this.accordionProgressValue = 0;
        }
    }

    startFromCard(index: number) {
        this.stopCardCycle('performanceCards');
        this.currentCardIndex = index;
        this.startCardProgress(true);
        this.startCardCycle();
    }

    startFromAccordion(accordionId: string) {
        this.stopCardCycle('productsAccordion');
        this.currentAccordionIndex = this.productsArr.findIndex((product: any) => product === accordionId);
        this.startAccordionProgress();
        this.startAccordionCycle();
        this.setProductImage();
    }

    startCardProgress(clickEvent: boolean = false) {
        this.cardProgressValue = 0;
        if (clickEvent) {
            this.cardProgressTimeoutId = setTimeout(() => {
                this.cardProgressIntervalId = this.intervalMethod(clickEvent);
            }, 500)
        } else {
            this.cardProgressIntervalId = this.intervalMethod(clickEvent);
        }
    }

    intervalMethod(clickEvent: boolean) {
        return setInterval(
            () => {
                this.cardProgressValue += 1;
                if (this.cardProgressValue >= 100) {
                    clearInterval(this.cardProgressIntervalId);
                }
            },
            clickEvent ? 51 : 54
        );
    }

    startAccordionProgress() {
        this.accordionProgressValue = 0;
        this.accordionProgressTimeoutId = setTimeout(() => {
            this.accordionProgressIntervalId = setInterval(() => {
                this.accordionProgressValue += 1;
                if (this.accordionProgressValue >= 100) {
                    clearInterval(this.accordionProgressIntervalId);
                }
            }, 87.5);
        }, 500);
    }

    onHover(index: any, type: string) {
        if (this.isSmallScreen$()) {
            return;
        }
        if (type === 'performanceCards') {
            if (this.currentCardIndex === index) {
                return;
            }
            this.hoverCardIndex = index;
            this.stopCardCycle('performanceCards');
            this.cardProgressValue = 0;
            this.showPerformanceCard = true;
        } else {
            this.hoverAccordionIndex = this.productsArr.findIndex((product: any) => product === index);
            if (this.currentAccordionIndex === this.hoverAccordionIndex) {
                return;
            }
            this.stopCardCycle('productsAccordion');
            this.accordionProgressValue = 0;
            this.accordion.expand(index);
            this.setProductImage();
        }
    }

    hoverOut(index: any, type: string) {
        if (this.isSmallScreen$()) {
            return;
        }
        if (type === 'performanceCards') {
            if (this.currentCardIndex === index || this.hoverCardIndex === -1) {
                return;
            }
            this.hoverCardIndex = -1;
            this.startFromCard(this.currentCardIndex);
        } else {
            const hoverAccordionId = this.productsArr.findIndex((product: any) => product === index);
            if (this.currentAccordionIndex === hoverAccordionId || this.hoverAccordionIndex === -1) {
                return;
            }
            this.onToggle(this.productsArr[this.currentAccordionIndex]);
            this.setProductImage();
        }
    }
}
